// extracted by mini-css-extract-plugin
module.exports = {"baseButton":"BaseButton_baseButton_1zqOI","isBold":"BaseButton_isBold_23Ih0"};